import React from "react";
import { withTranslation } from "react-i18next";
import { NextButton, SaveButton } from "../../shared/components/Buttons";
import { getIsSavingDraft } from "../../../data/booking/selectors/booking";
import { useDispatch, useSelector } from "react-redux";
import { saveDraft } from "../../../data/booking/actions/booking";

const SaveDraftButton = ({ t, className, disabled, ...props }) => {
    const dispatch = useDispatch();

    const isLoading = useSelector((state) => getIsSavingDraft(state.booking));

    return (
        <SaveButton
            disabled={disabled}
            loading={isLoading}
            loadingText={t("Sauvegarde de la demande...")}
            onClick={() => disabled!=true ? dispatch(saveDraft()):  null }
            className={className}
        >
            Enregistrer et revenir plus tard
        </SaveButton>
    );
};

export default withTranslation()(SaveDraftButton);
